module.exports = __webpack_public_path__ + "img/swipe-2-1.58c20e86.jpg";